import type { HttpClient } from '@wix/http-client'
import { saveItemPageSeoSchema } from './itemPageSeoSchema'

export const makeItemPageNonIndexable = async ({
  httpClient,
  pageId,
}: {
  httpClient: HttpClient
  pageId: string
}): Promise<void> => {
  await saveItemPageSeoSchema({
    httpClient,
    pageId,
    seoSchema: {
      tags: [{ type: 'meta', props: { name: 'robots', content: 'noindex' } }],
    },
  })
}
